import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CommentIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.424 9.202a.135.135 0 01-.108.12 5.054 5.054 0 00-1.914.78.135.135 0 01-.076.023h-2.94l-2.358 2.099a.27.27 0 01-.45-.203v-1.896H2.751a.79.79 0 01-.795-.784V2.813c0-.45.363-.813.811-.813h10.005c.447 0 .81.364.81.813v5.694a.135.135 0 01-.22.108l-.189-.15a1.08 1.08 0 00-1.75.737zm.96-.133a.266.266 0 01.285.032l2.163 1.723a.271.271 0 01.014.412l-2.163 1.97a.27.27 0 01-.452-.2v-.955c-3.324.132-3.783 2.689-3.79 2.722a.27.27 0 01-.266.227h-.022a.27.27 0 01-.248-.27c0-.047.05-4.517 4.326-4.697v-.72c0-.104.06-.199.153-.244z"
		></path>
	</svg>
))
